module.exports = __webpack_public_path__ + "e5686bf74d6c6ae7ddf16b5783ab8c13.png";